import { Div, Span, CollectionView, Snack } from "@tblabs/truffle";
import { Order } from "../../../../../../Models/Order";
import { OrdersManager } from "../../../../../../Services/OrdersManager";
import { Router } from "../../../../../../Services/Router";
import { TimeUtils } from "../../../../../../Utils/TimeUtils";
import { ContextMenu } from "../../../../../../Components/Utils/Menu";


export class OrderHeader extends Div
{
    constructor(_router: Router, _manager: OrdersManager, orders: CollectionView<Order>, order: Order)
    {
        super();
        this.DisplayInlineBlock().Margin(8).MinWidth(180).PositionRelative();

        this.Append(
            new ContextMenu({
                "👁️ Zobacz": () => _router.GoToOrderView(order.Id),
                "📝 Edytuj": () => _router.GoToOrderEdit(order.Id),
                "🍖 Raw": () => _router.GoToOrderRawEdit(order.Id),
                "👀 Widok klienta": () => _router.GoToCustomerView(order.Id),
                "💕 Duplikuj": async () =>
                {
                    const newOrder = await _manager.Duplicate(order);
                    new Snack(`☑️ Zamówienie #${order.ShortId} zostało zduplikowane jako #${newOrder.ShortId}`, "Nowe zamówienie jest gotowe do edycji");
                    _router.GoToOrderEdit(newOrder.Id);
                },
                "🗑️ Usuń": async () =>
                {
                    if (confirm(`Czy na pewno chcesz usunąć to zamówienie ${order.ShortId}?`))
                    {
                        await _manager.Delete(order);
                        orders.Collection.Remove(order); // TODO: gdyby kolekcja siedziała w menadżerze to nie trzeba by tej linijki...
                    }
                },
                "🔄 Regeneruj": () => _router.GoToOrderCreate(order.Id)
            }).DisplayInlineBlock(),
            new Span("#" + order.ShortId).MarginLeft(8).CursorPointer()
                .Style(order.IsClosed ? "text-decoration: line-through;" : "")
                .OnClick(() => _router.GoToOrderView(order.Id)),
            new Div().Append(order.CurrentStep?.GetStateName()).FontSize(12).Color("#3b82f6"),
            new Div().Text(`🐣 ${TimeUtils.HowLongAgo(order.Meta.CreatedAt)}\n⚡ ${TimeUtils.HowLongAgo(order.Meta.UpdatedAt, "jeszcze nie aktualizowany")}`)
                .FontSize(12).Color("#666").BorderTop(1, "#ccc", "dashed").MarginTop(4).PaddingTop(4),
        );
    }
}
